import React from "react";
import MultipleSelection from "../../../../components/MultipleSelection,";
import { useTranslation } from "../../../../hooks";
import { WalletType } from "@wallet-manager/node-types/dist/src/postgres/const";

interface IProps {
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  disabled?: boolean;
}

const WalletTypeMultipleSelection = (props: IProps) => {
  const { t } = useTranslation("tronWalletResourceBalance");

  const WalletTypeEnum = Object.fromEntries(
    Object.entries(WalletType).filter(([label, value]) => {
      return [1, 2, 3].includes(Number(value));
    })
  );

  return (
    <MultipleSelection
      label={props.label || t("psWalletType")}
      value={props.value}
      onChange={props.onChange}
      enumData={WalletTypeEnum}
      disabled={props.disabled}
    />
  );
};

export default WalletTypeMultipleSelection;
